import { StyledTag, TagText } from "./style";
import { AntTagProps } from "./types";
import { Popover } from "antd";
import { Text } from "components/Text";
import colors from "theme/colors.module.scss";
import iconMapping from "assets/icons/icons";

export const AntTag = ({
   text,
   icon,
   color,
   background,
   closeIcon,
   onClose,
   message,
   onClick,
   }: AntTagProps) => {
    const IconComponent = icon ? iconMapping[icon] : null;

    const tagElement = (
        <StyledTag
            color={color}
            background={background}
            closeIcon={closeIcon}
            onClose={onClose}
            style={{ cursor: message || onClick ? "pointer" : "default" }}
            onClick={(e) => { e.stopPropagation(); if (onClick) onClick(e); }}
        >
            {IconComponent && <IconComponent color={colors[color] ?? color} height={12} width={12} />}
            <TagText title={text}>{text}</TagText>
        </StyledTag>
    );

    return message ? (
        <Popover content={
            <Text $textVariant="pSM">{message}</Text>
        }
        >
            {tagElement}
        </Popover>
    ) : (
        tagElement
    );
};
